import { render, staticRenderFns } from "./CompanyValuesPage.vue?vue&type=template&id=78ee492e&scoped=true&"
import script from "./CompanyValuesPage.vue?vue&type=script&lang=js&"
export * from "./CompanyValuesPage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyValuesPage.vue?vue&type=style&index=0&id=78ee492e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ee492e",
  null
  
)

export default component.exports